import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isValidPhoneNumber } from 'react-phone-number-input';
import Navigation from '../../Components/Navigation';
import ButtonNext from '../../Components/ButtonNext';
import PhoneInput from 'react-phone-number-input/input'
import AppHeaderLogo from '../../Images/app-header_logo_2x.png';
import { trackGA4 } from '../../ga4';
import { getLandingVariant } from '../../config/landingVariants';

const GetInvited = ( {
  inviterPhoneNumber,
  inviteCode,
  mode,
  phoneNumber,
  setPhoneNumber,
  LOCAL_STORAGE_KEY_INVITER_PHONE_NUMBER,
  LOCAL_STORAGE_KEY_INVITE_CODE,
  LOCAL_STORAGE_KEY_MODE,
  SESSION_STORAGE_KEY_ATTRIBUTION,
  SESSION_STORAGE_KEY_LANDING_VARIANT,
} ) => {
  const navigate = useNavigate();
  const [buttonDisabled, setButtonDisabled] = useState(true)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [error, setError] = useState(false)
  const linkBack = ""
  const linkSkip = ""
  const phoneNumberStyle = { //Den här css ska över i css-fil. OBS: Den här behövs för att det inte ska bli lagg i css-laddning
    border: 'none',
    padding: '10px 10px 10px 10px',
    fontSize: '20px',
    fontFamily: 'Montserrat',
    textAlign: 'center',
    borderRadius: '40px',
    color: "#000",
    backgroundColor: "#fff"
  }
  // Helpers
  const asString = (v) => (typeof v === 'string' ? v : v ? String(v) : '');

  const saveInviteDataUrl = process.env.REACT_APP_CLOUD_FUNCTION_API_SAVEINVITEDATA
  const consumeInvitationCodeUrl = process.env.REACT_APP_CLOUD_FUNCTION_API_CONSUMEINVITATIONCODE

  const handleGoBack = () => {
    navigate('../app')
  }

    // Läs ett värde från sessionStorage (JSON.parse om möjligt, annars raw string)
  const readFromStorage = (key) => {
    try {
      const raw = sessionStorage.getItem(key);
      if (raw == null) return undefined;
      try {
        return JSON.parse(raw);
      } catch {
        return raw;
      }
    } catch {
      return undefined;
    }
  };

  // 🔹 Landningsvariant (resolvd i Step 1) → styr Step 2-copy. Fallback: buyer_default.
  const variant = getLandingVariant(readFromStorage(SESSION_STORAGE_KEY_LANDING_VARIANT));

    // 🔹 Wrapper för Meta Lead-event
  const trackMetaLead = () => {
    const attr = readFromStorage(SESSION_STORAGE_KEY_ATTRIBUTION);
    if (!attr?.isMetaTraffic) return;
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  };

  const handleRegisterInviteByCode = async (effectiveInviteCode) => {
    try {
      setError(false);
      setIsLoading(true);

      // Liten sanering – matchar serverns förväntningar (A–Z, 0–9)
      const code = String(effectiveInviteCode || '').toUpperCase().replace(/\s+/g, '');
      const attribution = readFromStorage(SESSION_STORAGE_KEY_ATTRIBUTION) || {};

      const resp = await fetch(consumeInvitationCodeUrl, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          inviteCode: code,
          invitedPhoneNumber: phoneNumber,
          attribution: attribution, // 🔹 NYTT: skicka med attrib-data
        }),
      });
      
      const result = await resp.json();
      
      if (result?.ok) {
        // ok === true (ev. result.already === true) → klart
        setIsLoading(false);
        navigate('../app/invite-completed');
        return;
      }

      // Hantera kända felkoder från backend
      const reason = result?.reason || '';
      if (reason === 'expired') {
        setErrorMessage(
          <p className='text-center text-xs text-[#EF4444]'>Koden har gått ut. Vill du{' '}
            <button onClick={handleGoBack} className="underline decoration-dotted">fylla i en annan kod?</button>
          </p>
        );
      } else if (reason === 'used') {
        setErrorMessage(
          <p className='text-center text-xs text-[#EF4444]'>Koden har förbrukats. Vill du{' '}
            <button onClick={handleGoBack} className="underline decoration-dotted">fylla i en annan kod?</button>
            </p>
          );
      } else {
        setErrorMessage(
          <p className='text-center text-xs text-[#EF4444]'>Ogiltig kod. Vill du{' '}
          <button onClick={handleGoBack} className="underline decoration-dotted">fylla i en annan kod?</button>
          </p>
        );
      }
      setIsLoading(false);
      setError(true);
    } catch (e) {
      setIsLoading(false);
      setErrorMessage(<p className='text-center text-xs text-[#EF4444]'>Något gick fel. Försök igen.</p>);
      setError(true);
    }
  };

  const handleRegisterInviteByFriend = async (effectiveInviterPhone) => {
    try {
      // Make sure not inviting themselves
      if (effectiveInviterPhone === phoneNumber) {
        setErrorMessage(
          <p className='text-center text-xs text-[#EF4444]'>Du kan inte bjuda in dig själv.</p>
        )
        setError(true)
        return
      }

      // Save invitee data
      setIsLoading(true)
      // Attribution behövs inte för inbjuden via vän (iaf just nu)
      // const attribution = readFromStorage(SESSION_STORAGE_KEY_ATTRIBUTION) || {};
      const response = await fetch(saveInviteDataUrl,{
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          inviterPhoneNumber: effectiveInviterPhone,
          invitedPhoneNumber: phoneNumber,
          // attribution: attribution // 🔹 NYTT: skicka med attrib-data -> Behövs inte för invite
        }),
      })
      const savedSuccessfully = await response.json()
      if (savedSuccessfully) {
        setIsLoading(false)
        navigate("../app/invite-completed") //Then navigate to next page   
      } else {
        setIsLoading(false)
        setErrorMessage(<p className='text-center text-xs text-[#EF4444]'>Något gick fel. Försök igen.</p>)
        setError(true)
      }
    } catch (e) {
      setIsLoading(false)
      setErrorMessage(<p className='text-center text-xs text-[#EF4444]'>Något gick fel. Försök igen.</p>)
      setError(true)
    }
  }

  // Huvud: läs persisted state först här (på CTA)
   // 🔹 CTA = “Lås upp min inbjudan” → trigga Meta Lead här
  const handleSubmit = (event) =>{
    event.preventDefault()
    setError(false)

    // Meta Lead – endast Meta-trafik
    trackMetaLead();

    // GA4 sign_up – all trafik
    trackGA4('sign_up', { method: mode });

    // 1) Lös “effective mode”
    const effectiveMode =
      mode ||
      asString(readFromStorage(LOCAL_STORAGE_KEY_MODE)) ||
      ''; // tomt om saknas

    if (!effectiveMode) {
      setError(true);
      setIsLoading(false);
      setErrorMessage(
        <p className='text-center text-xs text-[#EF4444]'>
          Hittar inte din inbjudan.{' '}
          <button onClick={handleGoBack} className="underline decoration-dotted">Gå tillbaka</button>{' '}
          och fyll i inbjudan igen.
        </p>
      );
      return;
    }

    // 2) Mode = 'code'
    if (effectiveMode === 'code') {
      const code =
        inviteCode ||
        asString(readFromStorage(LOCAL_STORAGE_KEY_INVITE_CODE)) ||
        '';

      if (!code) {
        setError(true);
        setIsLoading(false);
        setErrorMessage(
          <p className='text-center text-xs text-[#EF4444]'>
            Hittar ingen inbjudningskod.{' '}
            <button onClick={handleGoBack} className="underline decoration-dotted">Gå tillbaka</button>{' '}
            och fyll i koden.
          </p>
        );
        return;
      }

      handleRegisterInviteByCode(code);
      return;
    }

    // 3) Mode = 'friend'
    if (effectiveMode === 'friend') {
      const inviter =
        inviterPhoneNumber ||
        asString(readFromStorage(LOCAL_STORAGE_KEY_INVITER_PHONE_NUMBER)) ||
        '';

      if (!inviter) {
        setError(true);
        setIsLoading(false);
        setErrorMessage(
          <p className='text-center text-xs text-[#EF4444]'>
            Hittar ingen avsändare till inbjudan.{' '}
            <button onClick={handleGoBack} className="underline decoration-dotted">Gå tillbaka</button>{' '}
            och fyll i uppgifterna.
          </p>
        );
        return;
      }

      handleRegisterInviteByFriend(inviter);
      return;
    }

    // 4) Mode = okänt (edge)
    setError(true);
    setIsLoading(false);
    setErrorMessage(
      <p className='text-center text-xs text-[#EF4444]'>
        Okänt läge.{' '}
        <button onClick={handleGoBack} className="underline decoration-dotted">Gå tillbaka</button>{' '}
        och fyll i inbjudan igen.
      </p>
    );
  }

  useEffect(() => {
    const phone = asString(phoneNumber);
    const validPhone = phone ? isValidPhoneNumber(phone) : false;
    setButtonDisabled(!validPhone);
  }, [phoneNumber])

  return (
    <div className="flex flex-1 h-[calc(100dvh)] flex-col items-center justify-center bg-[#000]">
      {/* Top: brand + (ev. nav, samma som steg 1) */}
      <div className="flex flex-1 justify-between flex-col">
        <div className="mt-3">
          <img src={AppHeaderLogo} className='max-w-[100px]'/>
          {/* <h2 className="text-xl text-center text-[#fff]">houtine</h2> */}
        </div>
        <Navigation
          linkBack={linkBack}
          linkSkip={linkSkip}
          showLinkBack={false}
          showLinkSkip={false}
        />
      </div>

      {/* Middle: content (matchar steg 1 i width, padding och typografi) */}
      <div className="flex flex-1 justify-center flex-col w-full max-w-[420px] px-6">
        <div className="text-center mb-4">
          <p className="text-sm text-[#606060]">Nästan klart</p>
          <p className="text-sm text-[#606060]">Steg 2 av 2</p>
        </div>

        <h2 className="text-2xl sm:text-3xl font-semibold text-center leading-tight text-white mb-2">
          {variant.step2Heading}
        </h2>
        <p className="text-center text-sm sm:text-base text-[#D6D6D6] leading-relaxed mb-4">
          {variant.step2Subheading}
        </p>

        {/* Phone input */}
        <div className="flex justify-center">
          <PhoneInput
            country="SE"
            style={phoneNumberStyle}
            placeholder="07xxxxxxxx"
            value={phoneNumber}
            onChange={setPhoneNumber}
          />
        </div>
        {/* <p className="text-center text-xs text-[#9A9A9A] mt-3">
          Tips: Du kan klistra in ditt nummer med eller utan +46.
        </p> */}
      </div>

      {/* Bottom: CTA + errors (matchar spacing från steg 1) */}
      <div className="w-full flex flex-1 flex-col justify-center items-center max-w-[420px] px-6 mb-10">
        {error && <div>{errorMessage}</div>}
        <ButtonNext
          handleSubmit={handleSubmit}
          buttonDisabled={buttonDisabled}
          isLoading={isLoading}
          // error={error}
          // errorMessage={errorMessage}
          buttonText={variant.step2Cta} // buttonText={buttonDisabled ? variant.step2Cta : `${variant.step2Cta} 🎉`}
        />
        <p className="text-center text-xs text-[#9A9A9A] mt-3">
          Vi delar aldrig ditt nummer med någon annan.
        </p>
      </div>
    </div>
  );
}

export default GetInvited;
